import { render, staticRenderFns } from "./deliver-dialog.vue?vue&type=template&id=97770982&scoped=true&"
import script from "./deliver-dialog.vue?vue&type=script&lang=js&"
export * from "./deliver-dialog.vue?vue&type=script&lang=js&"
import style0 from "./deliver-dialog.vue?vue&type=style&index=0&id=97770982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97770982",
  null
  
)

export default component.exports